exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-container{display:flex;justify-content:center;flex-wrap:wrap;margin-bottom:20px}.product-card,.product-sm-card{border:1px solid #ddd;border-radius:8px;padding:20px;box-shadow:0 2px 4px rgba(0,0,0,.1);display:flex;flex-direction:column}.product-card{width:250px;margin:20px}.product-sm-card{width:150px;margin:10px}.product-title{margin-bottom:10px}.product-price,.product-title{font-size:14px;font-weight:700}.product-price{color:#556ee6;margin-top:auto}.carousel-controls{position:absolute;left:47%;display:flex;justify-content:center;margin-top:20px}.carousel-controls b-button{margin:0 10px}", ""]);

// exports
